// tslint:disable
/**
 * Dhimahi Webshop Online Ticket API
 * Version 1.0.0, provides API end points for front-end
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team.dws.jira@dhimahi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    LabelValue,
} from './index';

/**
 * Error response model used for all abnormal replies
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Error message
     * @type {string}
     * @memberof ErrorResponse
     */
    message: ErrorResponseMessageEnum;
    /**
     * Unique error code
     * @type {string}
     * @memberof ErrorResponse
     */
    code: string;
    /**
     * 
     * @type {Array<LabelValue>}
     * @memberof ErrorResponse
     */
    data?: Array<LabelValue>;
}

/**
* @export
* @enum {string}
*/
export enum ErrorResponseMessageEnum {
    NotFound = 'Not Found',
    BadRequest = 'Bad request',
    Forbidden = 'Forbidden',
    Unauthorized = 'Unauthorized',
    InternalServerError = 'Internal server error'
}


